const dataNavbarMobile = [
    {
        to: '/',
        class: 'home',
        title: 'HOME'
    },
    {
        to: '/shop',
        class: 'shop',
        title: 'SHOP'
    }
]
export default dataNavbarMobile;